import { GET, POST } from 'helpers/api'

const BASE = '/services/web/api/pos-notifications'

export async function fetchSince(posId, sinceId, limit = 100) {
	return await GET(BASE, { posId, sinceId, limit })
}

export async function markRead(posId, ids) {
	return await POST(BASE + '/read?posId=' + encodeURIComponent(posId), ids)
}

export async function fetchUnreadCount(posId) {
	return await GET(BASE + '/unread-count', { posId })
}
